/**
 * Automy.Core.Enums.Reporting.Identity.ReportTokenType
 * JSON `type` on ReportToken (integer). Tableau is tableau-connector, not a provider.
 */
export default Object.freeze({
  Administration: 1, // administration
  Process: 2, // process
  Request: 3, // request
  Generic: 4, // generic
  PowerBIConnector: 5, // power-bi-connector
  TableauConnector: 6, // tableau-connector
});
